exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mobile-error-form h1 {\n  font-size: 30px !important;\n}\n.mobile-error-form h3 {\n  font-size: 18px !important;\n}", ""]);
